import { useDateTimeRangeStore } from 'stores/useDateTimeRangeStore';

/**
 * Returns time range info for a customerLegalName or the DEFAULT
 */
export function useDateTimeRange(customerLegalName?: string): string | null {
  const { config, isLoaded } = useDateTimeRangeStore();

  if (!isLoaded || !config) return null;

  const key = customerLegalName?.toUpperCase();
  return config[key || ''] || config['DEFAULT'] || null;
}
